// src/internal/components/totp-risk-panel/totp-risk-panel.tsx
import { Box, Stack, Typography } from "@mui/material";
import { Translation } from "@clara/locale";
import { ZendeskButton } from "@clara/zendesk";
import { jsx, jsxs } from "react/jsx-runtime";
var TOTPRiskPanel = [
  {
    children: [
      {
        element: /* @__PURE__ */ jsx(Translation, { ns: "auth", children: (t) => /* @__PURE__ */ jsxs(Stack, { spacing: 4, children: [
          /* @__PURE__ */ jsx(
            Box,
            {
              component: "img",
              src: "https://clara-all-assets-prod.s3.amazonaws.com/security-2.svg",
              sx: {
                height: "160px"
              }
            }
          ),
          /* @__PURE__ */ jsxs(Stack, { spacing: 3, children: [
            /* @__PURE__ */ jsxs(Stack, { spacing: 1, children: [
              /* @__PURE__ */ jsx(Typography, { variant: "h2", fontWeight: 600, children: t("totp.riskSession.headline") }),
              /* @__PURE__ */ jsx(Typography, { variant: "body1", fontWeight: 600, children: t("totp.riskSession.tagline") })
            ] }),
            /* @__PURE__ */ jsx(Typography, { variant: "body1", children: t("totp.riskSession.subtitle") })
          ] })
        ] }) }),
        header: "",
        footer: /* @__PURE__ */ jsx(Translation, { ns: "common", children: (t) => /* @__PURE__ */ jsx(ZendeskButton, { title: t("metadata.links.helpCenterLabel") }) })
      }
    ]
  }
];

export {
  TOTPRiskPanel
};
